import React, { useState } from 'react';

const InjuriesLostTimeForm = ({ onFormSubmit, incidentId }) => {
    const [employeeName, setEmployeeName] = useState('');
    const [dateOfInjury, setDateOfInjury] = useState('');
    const [hoursLost, setHoursLost] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!employeeName || !dateOfInjury || !hoursLost) return;
        setLoading(true);
        onFormSubmit && onFormSubmit({ employeeName, dateOfInjury, hoursLost, description }, incidentId);
        setEmployeeName('');
        setDateOfInjury('');
        setHoursLost('');
        setDescription('');
        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: 400 }}>
            <div>
                <label>
                    Employee Name:
                    <input
                        type="text"
                        value={employeeName}
                        onChange={e => setEmployeeName(e.target.value)}
                        required
                    />
                </label>
            </div>
            <div>
                <label>
                    Date of Injury:
                    <input
                        type="date"
                        value={dateOfInjury}
                        onChange={e => setDateOfInjury(e.target.value)}
                        required
                    />
                </label>
            </div>
            <div>
                <label>
                    Hours Lost:
                    <input
                        type="number"
                        min="0"
                        value={hoursLost}
                        onChange={e => setHoursLost(e.target.value)}
                        required
                    />
                </label>
            </div>
            <div>
                <label>
                    Description (optional):
                    <textarea
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        rows={3}
                    />
                </label>
            </div>
            <button 
                type="submit" 
                disabled={loading}
                className={loading ? 'submit-button disabled' : 'submit-button'}
            >
                {loading ? "Submitting..." : "Submit"}
            </button>
        </form>
    );
};

export default InjuriesLostTimeForm;